"use client";

import { motion } from "framer-motion";
import React from "react";
import Image from "next/image";

import { MoondreamStation } from "@/components/moondream-station";
import { MiniTerminal } from "./mini-terminal";

const StationHero = () => {
  return (
    <section className="container relative py-16 mx-auto max-w-6xl overflow-hidden">
      <div className="mb-4 flex items-center justify-center gap-4">
        <h4 className="text-center text-lg font-semibold tracking-tight text-foreground">
          100% Free
        </h4>
      </div>

      <MoondreamStation className="mx-auto mb-6 w-2/3 max-w-lg md:max-w-2xl" />

      <p className="mx-auto mt-6 max-w-3xl text-center text-xl text-muted-foreground">
        Effortlessly run our state-of-the-art visual reasoning models locally. It&apos;s fast and free, with no technical headaches. Available on{" "}
        <a
          href="https://pypi.org/project/moondream-station/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary hover:underline"
        >
          PyPI
        </a>{" "}
        and{" "}
        <a
          href="https://github.com/m87-labs/moondream-station/tree/main"
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary hover:underline"
        >
          GitHub
        </a>
        .
      </p>

      <div className="relative mt-8 flex flex-col gap-4 items-center justify-center">
        <MiniTerminal />
        <video controls width="450" className="mt-6 mx-auto w-full max-w-3xl">
          <source
            src="https://d32juh9nlxrs68.cloudfront.net/station/mds2/MDS2-2.mp4"
            type="video/mp4"
          />
        </video>
      </div>

      <motion.div
        initial={{ opacity: 0, y: -250, scale: 0.6 }}
        animate={{ opacity: 100, y: 0, scale: 1 }}
        transition={{ ease: "easeInOut", duration: 0.6 }}
        className="-z-1 absolute -top-80 -right-80 hidden h-full w-240 items-center justify-center md:flex"
      >
        <Image
          className="infinite absolute w-full rotate-12 animate-spin duration-[300s] ease-linear"
          src="/images/station/orbit.svg"
          alt=""
          width={500}
          height={500}
        />
        <div className=" size-32 rounded-full bg-background p-7" />
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 250, scale: 0.6 }}
        animate={{ opacity: 100, y: 0, scale: 1 }}
        transition={{ ease: "easeInOut", duration: 0.6 }}
        className="-z-1 -bottom-80 -left-80 mt-32 -mb-24 flex h-full w-full items-center justify-center md:absolute md:w-240"
      >
        <Image
          className="infinite absolute w-full rotate-12 animate-spin duration-[300s] ease-linear"
          src="/images/station/orbit.svg"
          alt=""
          width={500}
          height={500}
        />
        <div className="size-32 rounded-full bg-background p-7" />
      </motion.div>
    </section>
  );
};

export { StationHero };
